/******************************************************************************
 * DashboardTimeToField: same-day emergency arrival delay for the period.     *
 *****************************************************************************/

import { useEffect, useState } from "react";
import { Card, Typography } from "@material-tailwind/react";
import { useTranslation } from "react-i18next";
import Loading from "../../components/loading/Loading";
import { fetchOverview } from "../statistics/services/statsApi";
import { formatDurationMinutes, toLocalDate } from "./dashboardPeriod";

export default function DashboardTimeToField({ from, to }: { from: Date; to: Date }) {
  const { t } = useTranslation();
  const [value, setValue] = useState<EasyTech.KpiValue | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setValue(null);
    fetchOverview({
      from: toLocalDate(from),
      to: toLocalDate(to),
      compare: "NONE"
    })
      .then((overview) => {
        if (!cancelled) setValue(overview.avgTimeToFieldMinutes);
      })
      .catch((err) => {
        console.error(err);
        if (!cancelled) setValue(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [from, to]);

  const sampled = value?.sampled;

  return (
    <div className="dashboard-time-to-field">
      <Typography>
        {t("stats:kpi.timeToField.label")}
      </Typography>
      <Card className="dashboard-time-to-field-card">
        {loading
          ? <Loading size="w-8 h-8" />
          : (
            <>
              <span className="dashboard-time-to-field-value">
                {formatDurationMinutes(value?.current)}
              </span>
              {sampled != null && sampled > 0 && (
                <span className="dashboard-time-to-field-sampled">
                  {t("common:dashboardTimeToField.sampled", { count: sampled })}
                </span>
              )}
            </>
          )}
      </Card>
    </div>
  );
}
